module.exports = __webpack_public_path__ + "static/media/Ppr.71d425b4.png";